import React, { useState, useEffect } from "react";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // หาก scrollY > 0 ให้แสดงปุ่ม
      setIsVisible(window.scrollY > 0);
    };

    // เพิ่ม event listener สำหรับ scroll
    window.addEventListener("scroll", handleScroll);

    // ลบ event listener เมื่อ component ถูก unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <div
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-4 right-4 bg-gray-600 p-2 cursor-pointer hover:bg-[#555555] transition-all duration-300"
        >
          <i className="fa fa-home text-white"></i>
        </div>
      )}
    </div>
  );
};

export default ScrollToTopButton;
